export default __webpack_public_path__ + "static/media/bruunRasmussen.591f55bc.svg";